import styled from "@emotion/styled";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Navbar from "./components/Navbar";
import Steps from "./components/Steps";
import Footer from "./components/Footer";
import BusinessSignupDescribed from "./components/BusinessSignupDescribed";
import UserAgreement from "./components/UserAgreement";

const Main = styled.main`
  max-width: 940px;
  margin: auto;
  height: 100%;
`;

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Navigate to="/business" />} />
        <Route
          path="/business"
          element={
            <>
              <Main className="App">
                <Navbar />
                <BusinessSignupDescribed />
                <Steps />
              </Main>
              <Footer />
            </>
          }
        />
        <Route
          path="/useragreement"
          element={
            <>
              <Main className="App">
                <Navbar />
                <UserAgreement />
              </Main>
              <Footer />
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
